import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { green } from "@mui/material/colors";

const greenForIcon = "#1a744d";
function CustomMaterialHelpListItem({
  text,
  icon,
  emphasizedInfoAfterText,
  emphasizedInfoBeforeText,
  sx,
}) {
  return (
    <ListItem
      sx={{
        ml: 2,
        marginTop: "1rem",
        marginBottom: "1rem",
        display: "flex",
        alignItems: "start",
        ...sx,
      }}
    >
      <ListItemAvatar>
        <Avatar
          sx={{
            width: "3.5rem",
            height: "3.5rem",
            bgcolor: greenForIcon,
          }}
        >
          {React.cloneElement(icon, { sx: { fontSize: "2rem" } })}
        </Avatar>
      </ListItemAvatar>
      <Typography
        paragraph
        sx={{
          ml: 2,
          fontSize: "2rem",
          fontWeight: 400,
          textAlign: "justify",
        }}
      >
        <b>{emphasizedInfoBeforeText}</b>
        {` ${text} `}
        <b>{emphasizedInfoAfterText}</b>
      </Typography>
    </ListItem>
  );
}

export default CustomMaterialHelpListItem;
